import { Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';

import {SearchPipe} from '../pipes/search';

import {ListItemComponent} from '../list_item/list_item.component'; 

import{ArticleService} from '../services/article.service';

import { Router } from '@angular/router';

import {AppSettings} from '../settings';

import {CommonService} from '../services/common.service';

 
declare var $: any;




@Component({
  selector: 'sp-panel',
  templateUrl: './searchPanel.component.html', 
  encapsulation:ViewEncapsulation.None,
 
})

export class SearchPanelComponent implements OnInit,OnChanges,AfterViewInit {

 @Input('index') i:number;

 @Input('newsletterid') newsletterid:number;
 

 
 @Input('nav') nav:any;

 @Input('showPanelIndex') showPanelIndex:number;

 @Output('showElement') showElement  = new EventEmitter();

 @Output('showSettingLeft') showSettingLeft  = new EventEmitter();
 
 @ViewChild("settingico",{static: false}) settingico;

 searchTxt:string='';

 currnav:number=0;
 details:any;
 oldnav:number=0;
 showLoadMore:boolean=true;
 showData:boolean=true
 eachliheight:number =175;  //57

  usertoken:any;

  url:any=AppSettings.API_ENDPOINT;

 show(i:number){

    this.showElement.emit({'index':i});
 }

 commonService:any;

constructor(private cmmonService:CommonService,private _router: Router,private articleService:ArticleService){

   let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
     
   if(!tokenA) throw 'Error in parse';
   
   if(!JSON.parse(tokenA)) throw 'Error in json parse';

   tokenA = JSON.parse(tokenA);

   this.usertoken=tokenA.token

   this.commonService = cmmonService; 

 

}

 

 

drag(ev:any,detail:any,type:string) {

     // console.log(ev);

      if(ev.dataTransfer!=undefined){
      ev.dataTransfer.setData("text",JSON.stringify({'action':'insert','nav_obj':detail,'type':type}));
      }

}

 ngOnInit(){

    this.currnav = this.nav.details.length;
    this.details=this.nav.details;
    this.oldnav=this.nav.details.length;
   
    
 }

 getHeight(){


    if(this.currnav > 4){

      //   return this.eachliheight*this.currnav+'px';
      return this.eachliheight+'px';
    }
 }


 
 navSetting(evt,index,tittle){

    //console.log(evt,index,tittle);

    this.showSettingLeft.emit({'evt':evt,'index':index,'tittle':tittle,'settingico':this.settingico.nativeElement.getBoundingClientRect()});
  
  }


 ngAfterViewInit() {
    
    $('document').ready(function(){
      
     $('#collapse0').addClass('collapse').addClass('show');
 
     });

    



 }

 article_pull(choice:string){

   switch(choice){

      case 'all':

     

      try{
        
         let data={
            token:this.usertoken,
            type:[this.nav.type], 
            page:'newsletter',
            group:'type'
          }
       
      this.articleService.articleData(data).subscribe( (res) =>{
         if(res.status=='success'){

            if(res.article && res.article[0]){

               this.nav.details=res.article[0].details; 

               this.currnav = (this.nav.details!=undefined)? this.nav.details.length:0;

            }else{
              this.nav.details=[]
              this.showData=false
              this.showLoadMore=false
            }

          }else{
            this._router.navigate(['/login']); 
         }
      })


      }catch(exc){
         
         this._router.navigate(['/login']); 
      } 

      break;

      case 'newsletter':

      

      try{
        
         let data={
            token:this.usertoken,
            type:[this.nav.type], 
            page:'newsletter',

            newsletter: this.newsletterid,
            group:'type'
          }
       
      this.articleService.articleData(data).subscribe( (res) =>{
         if(res.status=='success'){
           
            if(res.article && res.article[0]){
               this.nav.details=res.article[0].details; 
               this.currnav = (this.nav.details!=undefined)? this.nav.details.length:0;
            }else{
              this.nav.details=[]
              this.showData=false
              this.showLoadMore=false
            }

          }else{
            this._router.navigate(['/login']); 
         }
      })


      }catch(exc){
         
         this._router.navigate(['/login']); 
      } 





      break;
      

   }

 }


 initFilter(evt,type){
    
    if(type!=undefined){
      this.searchTxt = evt.target.value;
      
      if(this.searchTxt){
         try{
        
            let data={
               token:this.usertoken,
               type:[type],
               search:this.searchTxt,
               group:'type',
               page:"newsletter"
             }
          
         this.articleService.articleData(data).subscribe( (res) =>{
            if(res.status=='success'){
              
               if(res.article && res.article[0]){
                  this.nav.details=res.article[0].details;
                  this.currnav = (this.nav.details!=undefined)? this.nav.details.length:0;
               }else{
                 this.nav.details=[]
                 this.showData=false
               }
   
             }else{
               this._router.navigate(['/login']); 
            }
         })
   
   
         }catch(exc){
            
            this._router.navigate(['/login']); 
         } 
      }else{
         this.searchTxt=''
         this.currnav = this.oldnav;
         this.nav.details=this.details;
         this.showData=true
      }
      

    }else{
       
      this.searchTxt=''
      this.currnav = this.oldnav;
      this.nav.details=this.details;
      this.showData=true
      
    }
 

} 

loadMore(type){  
   try{
        
      let data={
         token:this.usertoken,
         type:[type],
         group:'type',
         search:this.searchTxt,
         offset: this.currnav,
         page: "newsletter"
       }
    
   this.articleService.articleData(data).subscribe( (res) =>{


      if(res.status=='success'){
         
         if(res.article && res.article[0]){
            
            let curr=this.nav.details;
            res.article[0].details.map((x,i)=>{
               curr.push(x)
            })
            this.nav.details=curr;
            this.currnav = this.nav.details.length;
            this.oldnav=this.currnav

         }else{  
            this.showLoadMore=false
         }

       }else{
         this._router.navigate(['/login']); 
      }
   })


   }catch(exc){
      
      this._router.navigate(['/login']); 
   }
  
}

 ngOnChanges(changes: SimpleChanges): void {



     
     if(this.showPanelIndex != changes.showPanelIndex.currentValue){

        this.showPanelIndex = changes.showPanelIndex.currentValue;
     }

   
    
 }




}
